import React, { useState } from 'react';
import './Trabajo.css';
import logo from '../../icons/trabaja.png';

const Trabajo = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    edad: '',
    cedula1: 'V',
    cedula2: '',
    sexo: '',
    estado: '',
    municipio: '',
    parroquia: '',
    direccion: '',
    telefono: '',
    cargo: '',
    funciones: '',
    postulacion: '',
    aporte: '',
    linkedin: '',
  });

  const [cvFile, setCvFile] = useState(null);

  if (!isOpen) return null;

  const handleOverlayClick = e => {
    // Si el clic fue en el overlay (fondo), cerrar modal
    if (e.target.classList.contains('job-modal-overlay')) {
      onClose();
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    // console.log("Datos del formulario:", formData);
    // console.log("Archivo CV:", cvFile);

    alert('Formulario enviado! Revisa la consola para ver los datos.');

    setFormData({
      nombre: '',
      edad: '',
      cedula1: 'V',
      cedula2: '',
      sexo: '',
      estado: '',
      municipio: '',
      parroquia: '',
      direccion: '',
      telefono: '',
      cargo: '',
      funciones: '',
      postulacion: '',
      aporte: '',
      linkedin: '',
    });
    setCvFile(null);
    onClose();
  };

  return (
    <div className="job-modal-overlay" onClick={handleOverlayClick}>
      {/* Contenedor azul grande por debajo */}
      <div className="job-modal-container-blue"></div>

      {/* Modal encima */}
      <div className="principal">
        <div className="job-modal">
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
          <h2 className="job-title">
            <span className="trabaja-bold">Trabaja</span>{' '}
            <span className="con-normal">con</span>
            <br />
            <span className="nosotros-bold">nosotros</span>
          </h2>
          <form className="job-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nombre y apellido"
              className="form-input"
              value={formData.nombre}
              onChange={e =>
                setFormData({ ...formData, nombre: e.target.value })
              }
              required
            />

            <div className="row">
              <input
                type="number"
                placeholder="Edad"
                className="form-input edad-input"
                value={formData.edad}
                onChange={e =>
                  setFormData({ ...formData, edad: e.target.value })
                }
                required
                min={0}
              />
              <div className="cedula-container">
                <select
                  className="cedula-select"
                  value={formData.cedula1}
                  onChange={e =>
                    setFormData({ ...formData, cedula1: e.target.value })
                  }
                >
                  <option value="V">V</option>
                  <option value="E">E</option>
                </select>
                <div className="cedula-separator"></div>
                <input
                  type="text"
                  placeholder="00"
                  className="cedula-input"
                  value={formData.cedula2}
                  onChange={e =>
                    setFormData({ ...formData, cedula2: e.target.value })
                  }
                  required
                  maxLength={8}
                />
              </div>
              <div className="sexo-container">
                Sexo
                <div className="sexo-option">
                  <span>M</span>
                  <input
                    type="radio"
                    name="sexo"
                    value="M"
                    checked={formData.sexo === 'M'}
                    onChange={e =>
                      setFormData({ ...formData, sexo: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="sexo-option">
                  <span>F</span>
                  <input
                    type="radio"
                    name="sexo"
                    value="F"
                    checked={formData.sexo === 'F'}
                    onChange={e =>
                      setFormData({ ...formData, sexo: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="location-row">
              <input
                type="text"
                placeholder="Estado"
                className="form-input location-input"
                value={formData.estado}
                onChange={e =>
                  setFormData({ ...formData, estado: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Municipio"
                className="form-input location-input"
                value={formData.municipio}
                onChange={e =>
                  setFormData({ ...formData, municipio: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Parroquia"
                className="form-input location-input"
                value={formData.parroquia}
                onChange={e =>
                  setFormData({ ...formData, parroquia: e.target.value })
                }
                required
              />
            </div>

            <input
              type="text"
              placeholder="Dirección"
              className="form-input"
              value={formData.direccion}
              onChange={e =>
                setFormData({ ...formData, direccion: e.target.value })
              }
              required
            />

            <div className="phone-container">
              <div className="phone-prefix">+58</div>
              <input
                type="tel"
                placeholder="Número de teléfono"
                className="phone-input"
                value={formData.telefono}
                onChange={e =>
                  setFormData({ ...formData, telefono: e.target.value })
                }
                required
                pattern="[0-9]{7,10}"
                title="Ingrese un número válido"
              />
            </div>

            <input
              type="text"
              placeholder="Último o actual Cargo desempeñado"
              className="form-input"
              value={formData.cargo}
              onChange={e =>
                setFormData({ ...formData, cargo: e.target.value })
              }
              required
            />

            <textarea
              placeholder="Funciones de ese cargo"
              className="form-textarea"
              value={formData.funciones}
              onChange={e =>
                setFormData({ ...formData, funciones: e.target.value })
              }
              required
            />

            <textarea
              placeholder="¿Por qué se postula para un Cargo en Biomercy?"
              className="form-textarea"
              value={formData.postulacion}
              onChange={e =>
                setFormData({ ...formData, postulacion: e.target.value })
              }
              required
            />

            <textarea
              placeholder="¿Qué le aportaría usted a nuestra Empresa?"
              className="form-textarea"
              value={formData.aporte}
              onChange={e =>
                setFormData({ ...formData, aporte: e.target.value })
              }
              required
            />

            <input
              type="url"
              placeholder="Link de LinkedIn"
              className="form-input"
              value={formData.linkedin}
              onChange={e =>
                setFormData({ ...formData, linkedin: e.target.value })
              }
            />

            <div className="file-input-container">
              <input
                type="file"
                id="cv-file"
                className="file-input"
                accept=".pdf,.doc,.docx"
                onChange={e => setCvFile(e.target.files[0])}
              />
              <label htmlFor="cv-file" className="file-input-label">
                Cargar CV
              </label>
              {cvFile && (
                <div style={{ fontSize: '9px', marginTop: '2px' }}>
                  {cvFile.name}
                </div>
              )}
            </div>

            <button type="submit" className="submit-btn">
              Enviar
            </button>
            <div className="logo">
              <img src={logo} alt="BIOMERCY" className="icono-trabajo" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Trabajo;
